// Subdomains that are infrastructure/environment hosts, never an org tenant.
// Mirrors the legacy `EXCLUDED_SUBDOMAINS` list so the sign-in page doesn't
// try to resolve branding for a staging/preview host.
const EXCLUDED_SUBDOMAINS = new Set([
  'staging',
  'release',
  'test',
  'www',
  'app',
]);

/**
 * Extract the organization subdomain from the current hostname.
 *
 * Returns '' (no tenant) for bare domains, `localhost`, single-label hosts,
 * and excluded infrastructure subdomains — matching legacy `getSubdomain`.
 * e.g. `svt.xthory.com` → `svt`; `xthory.com` → ''; `localhost` → ''.
 */
export const getSubdomain = (): string => {
  if (typeof window === 'undefined') return '';

  const host = window.location.hostname;
  const parts = host.split('.');

  // A tenant subdomain only exists when there are more than two labels
  // (`sub.domain.tld`). Bare domains and `localhost` have no tenant.
  if (parts.length <= 2) return '';

  const subdomain = parts[0];
  if (!subdomain || EXCLUDED_SUBDOMAINS.has(subdomain)) return '';

  return subdomain;
};
